import tw from 'twin.macro'
import { useContext } from 'react'
import { OnboardingsContext } from '../onboardings/Onboardings.context'
import { TableTagsSelect } from 'src/components/shared/table/TableTagsSelect'
import { TableSearch } from 'src/components/shared/table/TableSearch'

export const OnboardingsHeader = () => {
  const { setSearchQuery, searchQuery, tagsFilter, setTagsFilter } = useContext(OnboardingsContext)

  return (
    <div
      css={tw`flex flex-row items-center gap-4 bg-white px-4 py-3 border-0 border-b border-t border-solid border-[#EDEDED]`}
    >
      <TableSearch searchQuery={searchQuery} onChangeSearchQuery={setSearchQuery} />
      <TableTagsSelect selectedTags={tagsFilter} setSelectedTags={setTagsFilter} />
    </div>
  )
}
